import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditCollection from "../../components/collections/FormAddEditCollection";
import { useNavigate } from "react-router-dom";

const CreateCollection = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCollection
                isEdit={false}
                onSubmitSuccess={(res) => navigate(`/collections/${res.data.id}/edit`)}
            />
        </WrapperSection>
    );
};

export default CreateCollection;
